/* SiliDog Halloween — Spooky Pack bundle builder
   Reads its catalog from a JSON <script> the Liquid section renders, so every
   product, variant and price comes from the live store rather than being hardcoded.

   Flow mirrors the live bundle builder (sections/silidog-bundle-builder.liquid):
   click a tag -> popup -> choose colour/size + personalize -> Add to pack.

   CART PROPERTIES: line1..line4, matching the live bundle builder exactly.
   Fulfilment reads those keys. Do not rename them.

   PRICING: totals here are an ESTIMATE shown to the shopper. The real discount is
   applied by Shopify's automatic/tiered discounts at checkout. If the admin
   discount config and the tiers below disagree, checkout wins. Keep them in sync. */
(function () {
  'use strict';

  var root = document.querySelector('[data-sdhw]');
  if (!root) return;

  var dataEl = document.getElementById('sdhw-catalog');
  if (!dataEl) return;

  var CATALOG;
  try {
    CATALOG = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var PRODUCTS = CATALOG.products || [];
  var CFG = CATALOG.config || {};
  var MONEY_FMT = CFG.money_format || '${{amount}}';
  var FREE_SHIP_AT = CFG.free_ship_at || 4;
  var FREE_TAG_AT = CFG.free_tag_at || 0; // 0 = no free-tag reward
  var LADDER_MAX = FREE_TAG_AT || FREE_SHIP_AT;
  var POINTS_PER = CFG.points_per_tag || 200;
  var MAX_UNITS = 20;

  var DISCOUNT_TIERS = (CFG.tiers && CFG.tiers.length ? CFG.tiers : [
    { min: 4, rate: 0.20 }, { min: 3, rate: 0.15 }, { min: 2, rate: 0.10 }
  ]).slice().sort(function (a, b) { return b.min - a.min; });

  var byKey = {};
  PRODUCTS.forEach(function (p) { byKey[p.key] = p; });

  // Colour groups: products sharing a colour_group become swatches in one popup.
  var groups = {};
  PRODUCTS.forEach(function (p) {
    if (!p.colour_group) return;
    (groups[p.colour_group] = groups[p.colour_group] || []).push(p);
  });
  function siblingsOf(p) {
    return (p.colour_group && groups[p.colour_group]) ? groups[p.colour_group] : [p];
  }

  // pack = flat list of units: { key, variantId, fields:{line1..} }
  var pack = [];

  function rateFor(n) {
    for (var i = 0; i < DISCOUNT_TIERS.length; i++) {
      if (n >= DISCOUNT_TIERS[i].min) return DISCOUNT_TIERS[i].rate;
    }
    return 0;
  }

  function money(cents) {
    var amount = (cents / 100).toFixed(2);
    var withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return MONEY_FMT
      .replace(/\{\{\s*amount\s*\}\}/g, withCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(Math.round(cents / 100)));
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function variantOf(p, id) {
    if (!p.variants || !p.variants.length) return null;
    for (var i = 0; i < p.variants.length; i++) {
      if (String(p.variants[i].id) === String(id)) return p.variants[i];
    }
    return p.variants[0];
  }

  // Variant titles look like "Small (Collars up to 3/4\") / Blue" -> split into size/colour.
  function variantParts(v) {
    var bits = String(v.title || '').split(' / ');
    return { size: bits[0] || '', colour: bits.length > 1 ? bits[bits.length - 1] : '' };
  }
  function uniqueSizes(p) {
    var out = [], seen = {};
    (p.variants || []).forEach(function (v) {
      var s = variantParts(v).size;
      if (s && !seen[s]) { seen[s] = 1; out.push(s); }
    });
    return out.length > 1 ? out : [];
  }
  function uniqueColours(p) {
    var out = [], seen = {};
    (p.variants || []).forEach(function (v) {
      var c = variantParts(v).colour;
      if (c && !seen[c]) { seen[c] = 1; out.push(c); }
    });
    return out.length > 1 ? out : [];
  }
  function findVariant(p, size, colour) {
    var vs = p.variants || [];
    for (var i = 0; i < vs.length; i++) {
      var pt = variantParts(vs[i]);
      if ((!size || pt.size === size) && (!colour || pt.colour === colour)) return vs[i];
    }
    return vs[0] || null;
  }

  /* ---------------- modal ---------------- */

  var modal = root.querySelector('[data-sdhw-modal]');
  var M = {
    img: root.querySelector('[data-sdhw-modal-img]'),
    title: root.querySelector('[data-sdhw-modal-title]'),
    price: root.querySelector('[data-sdhw-modal-price]'),
    colorWrap: root.querySelector('[data-sdhw-modal-colorwrap]'),
    colorLabel: root.querySelector('[data-sdhw-modal-colorlabel]'),
    colors: root.querySelector('[data-sdhw-modal-colors]'),
    sizeWrap: root.querySelector('[data-sdhw-modal-sizewrap]'),
    sizes: root.querySelector('[data-sdhw-modal-sizes]'),
    fields: root.querySelector('[data-sdhw-modal-fields]'),
    hint: root.querySelector('[data-sdhw-modal-hint]'),
    confirm: root.querySelector('[data-sdhw-modal-confirm]')
  };

  // draft = what the popup is currently editing
  var draft = null;
  var lastFocus = null;

  function openModal(key, editIndex) {
    var p = byKey[key];
    if (!p || !modal) return;

    lastFocus = document.activeElement;

    var existing = (editIndex != null) ? pack[editIndex] : null;
    var startKey = existing ? existing.key : key;
    var startP = byKey[startKey] || p;

    draft = {
      key: startKey,
      group: siblingsOf(startP),
      variantId: existing ? existing.variantId : (startP.variants[0] && startP.variants[0].id),
      fields: {},
      editIndex: (editIndex != null) ? editIndex : null
    };
    (startP.fields || []).forEach(function (f) {
      draft.fields[f.k] = existing ? (existing.fields[f.k] || '') : '';
    });

    renderModal();
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';

    var firstInput = M.fields.querySelector('input');
    if (firstInput) setTimeout(function () { firstInput.focus(); }, 40);

    if (M.confirm) M.confirm.textContent = existing ? 'Save changes' : 'Add to pack';
  }

  function closeModal() {
    if (!modal) return;
    modal.hidden = true;
    draft = null;
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function renderModal() {
    if (!draft) return;
    var p = byKey[draft.key];
    var v = variantOf(p, draft.variantId);

    // The popup deliberately shows the real product photo (shot on white) — the
    // shopper is choosing an actual variant here, not looking at decorative art.
    if (M.img) { M.img.src = p.photo || p.image || ''; M.img.alt = p.name || ''; }
    if (M.title) M.title.textContent = p.name || '';
    if (M.price) M.price.textContent = v ? money(v.price) : '';

    // --- colour row: sibling products first, else variant colours ---
    var html = '';
    var sibs = draft.group || [p];
    if (sibs.length > 1) {
      if (M.colorLabel) M.colorLabel.textContent = 'Colour';
      sibs.forEach(function (sp) {
        html += '<button type="button" role="radio" class="sdhw-swatch' + (sp.key === draft.key ? ' on' : '') + '"'
          + ' aria-checked="' + (sp.key === draft.key ? 'true' : 'false') + '"'
          + ' data-sdhw-pick-product="' + esc(sp.key) + '" title="' + esc(sp.colour_name || sp.name) + '">'
          + '<span class="dot" style="background:' + esc(sp.swatch || '#ff8a3d') + '"></span>'
          + '<span class="lbl">' + esc(sp.colour_name || sp.name) + '</span>'
          + '</button>';
      });
    } else {
      var cols = uniqueColours(p);
      if (cols.length) {
        if (M.colorLabel) M.colorLabel.textContent = 'Colour';
        var curC = v ? variantParts(v).colour : '';
        cols.forEach(function (c) {
          html += '<button type="button" role="radio" class="sdhw-swatch' + (c === curC ? ' on' : '') + '"'
            + ' aria-checked="' + (c === curC ? 'true' : 'false') + '"'
            + ' data-sdhw-pick-colour="' + esc(c) + '">'
            + '<span class="dot" style="background:' + esc(colourToCss(c)) + '"></span>'
            + '<span class="lbl">' + esc(c) + '</span>'
            + '</button>';
        });
      }
    }
    if (M.colors) M.colors.innerHTML = html;
    if (M.colorWrap) M.colorWrap.hidden = !html;

    // --- size row (multi-variant products only) ---
    var sizes = uniqueSizes(p);
    var sHtml = '';
    if (sizes.length) {
      var curS = v ? variantParts(v).size : '';
      sizes.forEach(function (sz) {
        sHtml += '<button type="button" role="radio" class="sdhw-size' + (sz === curS ? ' on' : '') + '"'
          + ' aria-checked="' + (sz === curS ? 'true' : 'false') + '"'
          + ' data-sdhw-pick-size="' + esc(sz) + '">' + esc(sz) + '</button>';
      });
    }
    if (M.sizes) M.sizes.innerHTML = sHtml;
    if (M.sizeWrap) M.sizeWrap.hidden = !sHtml;

    // --- personalization fields ---
    var fHtml = '';
    (p.fields || []).forEach(function (f) {
      var val = draft.fields[f.k] || '';
      fHtml += '<label class="sdhw-modal-field">'
        + '<span class="sdhw-modal-field-label">' + esc(f.label || f.k)
        + (f.req ? ' <span class="req">required</span>' : ' <span class="opt">optional</span>')
        + '</span>'
        + '<input type="text" data-sdhw-field="' + esc(f.k) + '" maxlength="' + (f.max || 20) + '"'
        + ' placeholder="' + esc(f.p || '') + '" value="' + esc(val) + '" autocomplete="off"'
        + (f.req ? ' aria-required="true"' : '') + '>'
        + '</label>';
    });
    if (M.fields) M.fields.innerHTML = fHtml;

    validateModal(true);
  }

  // Map common colour words to a CSS colour for the swatch dot.
  var COLOUR_MAP = {
    blue: '#1565ff', red: '#e02b2b', white: '#f4f4f6', yellow: '#ffcf33',
    orange: '#ff8a3d', pink: '#ff6fa5', purple: '#8a5cf6', green: '#3aa655',
    black: '#15171c', silver: '#c8ccd4', gold: '#d4a437', teal: '#14b8a6'
  };
  function colourToCss(name) {
    return COLOUR_MAP[String(name || '').trim().toLowerCase()] || '#ff8a3d';
  }

  function validateModal(silent) {
    if (!draft) return false;
    var p = byKey[draft.key];
    var missing = (p.fields || []).filter(function (f) {
      return f.req && !String(draft.fields[f.k] || '').trim();
    });
    var ok = missing.length === 0;
    if (M.confirm) {
      M.confirm.disabled = !ok;
      M.confirm.setAttribute('aria-disabled', ok ? 'false' : 'true');
    }
    if (M.hint) {
      if (!ok && !silent) {
        M.hint.textContent = 'Enter your pet’s name';
        M.hint.hidden = false;
      } else {
        M.hint.hidden = true;
      }
    }
    return ok;
  }

  function confirmModal() {
    if (!draft || !validateModal(false)) return;
    var unit = { key: draft.key, variantId: draft.variantId, fields: {} };
    var p = byKey[draft.key];
    (p.fields || []).forEach(function (f) { unit.fields[f.k] = draft.fields[f.k] || ''; });

    if (draft.editIndex != null) pack[draft.editIndex] = unit;
    else if (pack.length < MAX_UNITS) pack.push(unit);

    closeModal();
    render();
  }

  /* ---------------- summary + totals ---------------- */

  function subtotalCents() {
    return pack.reduce(function (s, u) {
      var v = variantOf(byKey[u.key], u.variantId);
      return s + (v ? v.price : 0);
    }, 0);
  }

  function renderProgress(count) {
    // Stops sit at equal thirds (2, 3, 4 tags); the first tag fills half of the first third.
    var pct = count >= LADDER_MAX ? 100 : count < 2 ? count * (100 / 6) : ((count - 1) / (LADDER_MAX - 1)) * 100;
    var fill = root.querySelector('#sdhw-rpFill');
    var pump = root.querySelector('#sdhw-rpPumpkin');
    if (fill) fill.style.width = pct + '%';
    if (pump) pump.style.left = pct + '%';
    root.querySelectorAll('.sdhw-rp-stop').forEach(function (stop) {
      stop.classList.toggle('hit', count >= parseInt(stop.getAttribute('data-at'), 10));
    });
    var map = {
      0: 'Add tags to start saving', 1: '1 more tag → 10% off', 2: '1 more → 15% off',
      3: '1 more → 20% off + free shipping'
    };
    var text = root.querySelector('#sdhw-rpText');
    var cnt = root.querySelector('#sdhw-rpCount');
    if (text) text.textContent = count >= LADDER_MAX ? 'All rewards unlocked!' : (map[count] || '');
    if (cnt) cnt.textContent = count ? count + ' tag' + (count > 1 ? 's' : '') : '';
  }

  function render() {
    var count = pack.length;
    var sub = subtotalCents();
    var r = rateFor(count);
    // Shopify allocates the % per line and rounds each line down; mirror it so the estimate matches checkout to the cent.
    var disc = pack.reduce(function (d, u) {
      var v = variantOf(byKey[u.key], u.variantId);
      return d + (v ? Math.floor(v.price * r + 1e-6) : 0);
    }, 0);
    var total = sub - disc;

    renderProgress(count);

    // per-card count badges + in-pack ring
    PRODUCTS.forEach(function (p) {
      var n = pack.filter(function (u) { return u.key === p.key; }).length;
      var badge = root.querySelector('#sdhw-q-' + CSS.escape(p.key));
      if (badge) {
        badge.textContent = n;
        badge.hidden = n === 0;
        badge.setAttribute('data-count', n);
      }
      var card = root.querySelector('#sdhw-card-' + CSS.escape(p.key));
      if (card) card.classList.toggle('in-pack', n > 0);
    });

    var empty = root.querySelector('#sdhw-empty');
    var list = root.querySelector('#sdhw-list');
    var totals = root.querySelector('#sdhw-totals');
    var cta = root.querySelector('#sdhw-cta');
    var pts = root.querySelector('#sdhw-points');
    var nudge = root.querySelector('#sdhw-nudge');
    var free = root.querySelector('#sdhw-free');

    if (count === 0) {
      if (empty) empty.style.display = 'block';
      if (list) list.innerHTML = '';
      if (totals) totals.style.display = 'none';
      if (nudge) nudge.style.display = 'none';
      if (free) free.style.display = 'none';
      if (cta) { cta.disabled = true; cta.textContent = 'Add pack to cart'; }
      if (pts) pts.textContent = '';
      return;
    }

    if (empty) empty.style.display = 'none';
    if (totals) totals.style.display = 'block';

    var html = '';
    pack.forEach(function (u, i) {
      var p = byKey[u.key];
      var v = variantOf(p, u.variantId);
      var vp = v ? variantParts(v) : { size: '', colour: '' };
      var summary = (p.fields || []).map(function (f) { return u.fields[f.k]; })
        .filter(Boolean).join(' · ');
      html += '<div class="sdhw-bl-item" data-i="' + i + '">'
        + '<span class="sdhw-bl-thumb' + (p.cutout ? ' is-cutout' : '') + '">'
        + (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : '') + '</span>'
        + '<span class="sdhw-bl-main">'
        + '<span class="sdhw-bl-name">' + esc(p.name) + '</span>'
        + (vp.colour || vp.size ? '<span class="sdhw-bl-var">' + esc([vp.size, vp.colour].filter(Boolean).join(' · ')) + '</span>' : '')
        + '<span class="sdhw-bl-eng">' + (summary ? esc(summary) : '<em>No text</em>') + '</span>'
        + '</span>'
        + '<span class="sdhw-bl-right">'
        + '<span class="sdhw-bl-p">' + (v ? money(v.price) : '') + '</span>'
        + '<span class="sdhw-bl-acts">'
        + '<button type="button" class="sdhw-bl-edit" data-sdhw-edit="' + i + '" aria-label="Edit ' + esc(p.name) + '">Edit</button>'
        + '<button type="button" class="sdhw-bl-del" data-sdhw-remove="' + i + '" aria-label="Remove ' + esc(p.name) + '">&times;</button>'
        + '</span></span>'
        + '</div>';
    });
    if (list) list.innerHTML = html;

    var subEl = root.querySelector('#sdhw-btSub');
    if (subEl) subEl.textContent = money(sub);

    var discRow = root.querySelector('#sdhw-btDiscRow');
    if (discRow) {
      if (r > 0) {
        discRow.style.display = 'flex';
        var dl = root.querySelector('#sdhw-btDiscLabel');
        var dv = root.querySelector('#sdhw-btDisc');
        if (dl) dl.textContent = 'Bundle discount (' + Math.round(r * 100) + '% off)';
        if (dv) dv.textContent = '-' + money(disc);
      } else discRow.style.display = 'none';
    }

    var ship = root.querySelector('#sdhw-btShip');
    if (ship) ship.textContent = count >= FREE_SHIP_AT ? 'FREE' : 'Calculated at checkout';

    var was = root.querySelector('#sdhw-btWas');
    if (was) {
      if (r > 0) { was.style.display = 'inline'; was.textContent = money(sub); }
      else was.style.display = 'none';
    }
    var totEl = root.querySelector('#sdhw-btTotal');
    if (totEl) totEl.textContent = money(total);

    var msg;
    if (count === 1) msg = 'Add 1 more tag to unlock 10% off 🎃';
    else if (count === 2) msg = 'Add 1 more to bump your discount to 15%';
    else if (count === 3) msg = 'Add 1 more for 20% off + FREE shipping';
    else msg = 'Max savings unlocked — 20% off + free shipping! 🕸️';
    if (nudge) { nudge.style.display = 'block'; nudge.textContent = msg; }
    if (free) free.style.display = FREE_TAG_AT && count >= FREE_TAG_AT ? 'block' : 'none';

    if (cta) { cta.disabled = false; cta.textContent = 'Add pack to cart · ' + money(total); }
    if (pts) pts.textContent = 'You’ll earn ' + (count * POINTS_PER) + ' reward points (2× spooky bonus)';
  }

  /* ---------------- add to cart ---------------- */

  function addPackToCart() {
    var cta = root.querySelector('#sdhw-cta');
    var err = root.querySelector('#sdhw-err');
    if (!cta || cta.disabled || !pack.length) return;

    var items = pack.map(function (u) {
      var props = {};
      // line1..line4 — same keys the live bundle builder sends. Fulfilment reads these.
      Object.keys(u.fields).forEach(function (k) {
        var val = String(u.fields[k] || '').trim();
        if (val) props[k] = val;
      });
      props._spooky_pack = 'halloween-2026';
      return { id: Number(u.variantId), quantity: 1, properties: props };
    });

    var original = cta.textContent;
    cta.disabled = true;
    cta.textContent = 'Adding…';
    if (err) err.style.display = 'none';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) throw new Error(body && body.description ? body.description : 'Could not add to cart.');
          return body;
        });
      })
      .then(function () { window.location.href = CFG.cart_url || '/cart'; })
      .catch(function (e) {
        cta.disabled = false;
        cta.textContent = original;
        if (err) { err.textContent = e.message || 'Something went wrong. Please try again.'; err.style.display = 'block'; }
      });
  }

  /* ---------------- events ---------------- */

  root.addEventListener('click', function (e) {
    var open = e.target.closest('[data-sdhw-open]');
    if (open) { e.preventDefault(); openModal(open.getAttribute('data-key')); return; }

    if (e.target.closest('[data-sdhw-modal-close]')) { e.preventDefault(); closeModal(); return; }

    var pickP = e.target.closest('[data-sdhw-pick-product]');
    if (pickP && draft) {
      e.preventDefault();
      var nk = pickP.getAttribute('data-sdhw-pick-product');
      var np = byKey[nk];
      if (np) {
        // carry the typed text across to the newly chosen colour
        var carried = {};
        (np.fields || []).forEach(function (f) { carried[f.k] = draft.fields[f.k] || ''; });
        draft.key = nk;
        draft.variantId = np.variants[0] && np.variants[0].id;
        draft.fields = carried;
        renderModal();
      }
      return;
    }

    var pickC = e.target.closest('[data-sdhw-pick-colour]');
    if (pickC && draft) {
      e.preventDefault();
      var p1 = byKey[draft.key];
      var cur1 = variantOf(p1, draft.variantId);
      var nv = findVariant(p1, cur1 ? variantParts(cur1).size : '', pickC.getAttribute('data-sdhw-pick-colour'));
      if (nv) { draft.variantId = nv.id; renderModal(); }
      return;
    }

    var pickS = e.target.closest('[data-sdhw-pick-size]');
    if (pickS && draft) {
      e.preventDefault();
      var p2 = byKey[draft.key];
      var cur2 = variantOf(p2, draft.variantId);
      var nv2 = findVariant(p2, pickS.getAttribute('data-sdhw-pick-size'), cur2 ? variantParts(cur2).colour : '');
      if (nv2) { draft.variantId = nv2.id; renderModal(); }
      return;
    }

    if (e.target.closest('[data-sdhw-modal-confirm]')) { e.preventDefault(); confirmModal(); return; }

    var edit = e.target.closest('[data-sdhw-edit]');
    if (edit) {
      e.preventDefault();
      var ei = parseInt(edit.getAttribute('data-sdhw-edit'), 10);
      if (pack[ei]) openModal(pack[ei].key, ei);
      return;
    }

    var rm = e.target.closest('[data-sdhw-remove]');
    if (rm) {
      e.preventDefault();
      pack.splice(parseInt(rm.getAttribute('data-sdhw-remove'), 10), 1);
      render();
      return;
    }

    var cat = e.target.closest('.sdhw-cat');
    if (cat && !cat.disabled) {
      e.preventDefault();
      applyCat(cat);
      // Mobile side rail is sticky: if the grid top has scrolled away, bring it back under the bar.
      var wrap = root.querySelector('.sdhw-wrap');
      if (wrap && window.matchMedia('(max-width: 749px)').matches) {
        var railTop = parseFloat(getComputedStyle(root).getPropertyValue('--sdhw-rail-top')) || 112;
        var gy = wrap.getBoundingClientRect().top;
        if (gy < railTop) window.scrollTo({ top: window.scrollY + gy - railTop, behavior: 'smooth' });
      }
      return;
    }

    if (e.target.closest('.sdhw-glow-toggle')) {
      e.preventDefault();
      var on = root.classList.toggle('lights-off');
      var gt = root.querySelector('.sdhw-glow-toggle');
      if (gt) gt.setAttribute('aria-pressed', on ? 'true' : 'false');
      return;
    }

    if (e.target.closest('#sdhw-cta')) { e.preventDefault(); addPackToCart(); }
  });

  root.addEventListener('input', function (e) {
    var f = e.target.closest('[data-sdhw-field]');
    if (f && draft) {
      draft.fields[f.getAttribute('data-sdhw-field')] = f.value;
      validateModal(true);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
  });

  // Filter the grid to one rail category. In "All", a product listed under two
  // categories (e.g. Best sellers + Bones) shows once — its first card wins.
  function applyCat(cat) {
    var want = cat.getAttribute('data-cat');
    var seen = {};
    root.querySelectorAll('.sdhw-cat').forEach(function (c) { c.classList.toggle('on', c === cat); });
    root.querySelectorAll('.sdhw-bp-card').forEach(function (card) {
      var cc = card.getAttribute('data-cat');
      if (!cc) { card.classList.toggle('cat-hide', want !== 'all'); return; }
      var hide = want !== 'all' && cc !== want;
      if (want === 'all') {
        var pid = card.getAttribute('data-pid');
        if (pid && seen[pid]) hide = true;
        if (pid) seen[pid] = true;
      }
      card.classList.toggle('cat-hide', hide);
    });
  }

  var rail = root.querySelector('.sdhw-cat-rail');
  var startCat = rail && rail.getAttribute('data-default-cat');
  var startBtn = startCat && root.querySelector('.sdhw-cat[data-cat="' + startCat + '"]');
  applyCat(startBtn || root.querySelector('.sdhw-cat[data-cat="all"]'));

  render();
})();
